const valueFrom = (
    payload,
    key,
    fallback = "—"
) => {

    const nested =
        payload?.payload ??
        {};


    return (
        payload?.[key] ??
        nested?.[key] ??
        fallback
    );
};


export function SetupPanel({
    candidate,
    gemini,
}) {

    const grade =
        valueFrom(
            candidate,
            "grade"
        );


    const score =
        valueFrom(
            candidate,
            "score"
        );


    const symbol =
        candidate?.symbol ??
        valueFrom(
            candidate,
            "symbol"
        );


    const direction =
        valueFrom(
            candidate,
            "direction"
        );


    const analysis =
        gemini?.payload?.analysis ??
        gemini?.payload?.result ??
        gemini?.analysis ??
        null;


    return (
        <div className="rounded-2xl border border-slate-800 bg-slate-900/70 p-5 shadow-xl shadow-black/10">

            <div className="mb-4 flex items-center justify-between">

                <div>
                    <p className="text-sm font-semibold text-slate-100">
                        Latest Setup
                    </p>

                    <p className="text-xs text-slate-500">
                        Deterministic SMC arbitration
                    </p>
                </div>

                <span className="rounded-full border border-blue-500/30 bg-blue-500/10 px-3 py-1 text-xs text-blue-300">
                    {symbol}
                </span>

            </div>


            <div className="grid grid-cols-3 gap-3">

                <div className="rounded-xl bg-slate-950/70 p-3">
                    <p className="text-xs text-slate-500">
                        Grade
                    </p>

                    <p className="mt-1 text-lg font-semibold text-slate-100">
                        {grade}
                    </p>
                </div>


                <div className="rounded-xl bg-slate-950/70 p-3">
                    <p className="text-xs text-slate-500">
                        Score
                    </p>

                    <p className="mt-1 text-lg font-semibold text-slate-100">
                        {score}
                    </p>
                </div>


                <div className="rounded-xl bg-slate-950/70 p-3">
                    <p className="text-xs text-slate-500">
                        Direction
                    </p>

                    <p className="mt-1 text-lg font-semibold text-slate-100">
                        {direction}
                    </p>
                </div>

            </div>


            <div className="mt-4 rounded-xl border border-slate-800 bg-slate-950/50 p-4">

                <div className="flex items-center justify-between">

                    <p className="text-xs font-semibold uppercase tracking-wider text-slate-500">
                        Gemini Analyst
                    </p>

                    <span className="text-xs text-amber-300">
                        ANALYST ONLY
                    </span>

                </div>


                <p className="mt-2 text-sm leading-6 text-slate-300">
                    {analysis?.summary ??
                        "No Gemini analysis received for the latest setup."}
                </p>

            </div>

        </div>
    );
}